<template>
    <b2b-policy-type-dialog
        :links="policyTypesArray"
        :hideButton="true"
        :toDisplay="toDisplay"
        @changeDialog="changeDialog"
    ></b2b-policy-type-dialog>
</template>

<script>
    import _ from 'lodash'
    import PolicyTypeDialogButton from "./PolicyTypeDialogButton";
    export default {
        name: "PolicyDialogCustom",
        props: ['policyTypes'],
        components: {
            'b2b-policy-type-dialog': PolicyTypeDialogButton
        },
        data: () => ({
            toDisplay: false,
            policyTypesArray: []
        }),
        created() {
            this.policyTypesArray = JSON.parse(window.atob(this.policyTypes));
            let newPolisButtons = [...document.getElementsByClassName('newPolis')]
            newPolisButtons.forEach((item) => {
                item.addEventListener('click', (e) => {
                    e.preventDefault()
                    this.toDisplay = true
                })
            })
        },
        methods: {
            changeDialog(value) {
                this.toDisplay = value
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/js/components/elements/PolicyDialogCustom.vue